var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 147,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68 44.099c0-22.326 18.099-40.425 40.425-40.425h58.8c22.326 0 40.425 18.099 40.425 40.425v58.8c0 22.326-18.099 40.425-40.425 40.425h-58.8c-22.326 0-40.425-18.099-40.425-40.425v-58.8z",
    stroke: "#F9B035",
    strokeWidth: 7.35
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 31,
    width: 84,
    height: 85
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.076 31.969H31.012v83.064h83.064V31.969z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    fill: "#F9B035"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.555 104.654c17.204 0 31.15-13.946 31.15-31.15 0-17.203-13.946-31.149-31.15-31.149-17.203 0-31.149 13.946-31.149 31.15 0 17.203 13.946 31.149 31.15 31.149zm0-10.384c11.47 0 20.766-9.297 20.766-20.766 0-11.469-9.296-20.766-20.766-20.766-11.468 0-20.766 9.297-20.766 20.766 0 11.469 9.298 20.766 20.766 20.766z",
    stroke: "#F9B035",
    strokeWidth: 3.675
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.902 42.352a5.191 5.191 0 10.001-10.383 5.191 5.191 0 00-.001 10.383z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIconYellow);
export default __webpack_public_path__ + "static/media/instagram-icon-yellow.feebd23ed18c2b16049cccf329a6d567.svg";
export { ForwardRef as ReactComponent };